<template>
  <div class="user-main">
    <div class="user-head">
      <ul>
        <li>{{user.name}}</li>
        <li>
          <b-icon icon="file-earmark-text-fill"></b-icon> 
          {{user.assignedTickets.length}}
        </li>
      </ul>
    </div>
    <div class="user-body">
      <TicketCard v-for="ticket in tickets" :ticket='ticket' :key='ticket.id'/>
    </div>
  </div>
</template>

<script>
import TicketCard from '../components/TicketCard.vue'

export default {
  name: 'UserCard',
  components: {
    TicketCard
  },
  props: {
    user: Object
  },
  computed: {
    tickets() {
      return this.user.assignedTickets
    }
  }
}
</script>

<style>
@import '../styles/user-card.min.css';
</style>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/components/UserCard.vue